import styled, { css } from 'styled-components'
import { colors, fieldLabel, fontScope, radius } from '../tokens'

export const Field = styled.div<{ $inline: boolean }>`
  ${fontScope}
  display: flex;
  min-width: 0;
  ${({ $inline }) =>
    $inline
      ? css`
          flex-direction: row;
          align-items: center;
          gap: 10px;
        `
      : css`
          flex-direction: column;
          gap: 6px;
        `}
`

export const Label = styled.label<{ $inline: boolean, $dense: boolean }>`
  ${fieldLabel}
  white-space: nowrap;
  ${({ $inline }) => $inline && css`color: ${colors.ink500};`}
  ${({ $dense }) =>
    $dense &&
    css`
      line-height: normal;
      letter-spacing: 0;
    `}
`

export const Box = styled.div<{ $width?: string }>`
  position: relative;
  display: flex;
  align-items: center;
  width: ${({ $width }) => $width ?? '100%'};
  min-width: 0;
`

export const Select = styled.select<{ $placeholder: boolean }>`
  width: 100%;
  min-height: 40px;
  box-sizing: border-box;
  padding: 10px 32px 10px 16px;
  border: 1px solid ${colors.border};
  border-radius: ${radius.input};
  background: ${colors.white};
  appearance: none;
  outline: none;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: ${({ $placeholder }) => ($placeholder ? colors.ink500 : colors.ink950)};
  text-overflow: ellipsis;
  cursor: pointer;

  &:focus-visible {
    border-color: ${colors.ink400};
  }

  &:disabled {
    cursor: not-allowed;
    color: ${colors.ink400};
  }
`

export const Chevron = styled.img`
  position: absolute;
  right: 8px;
  pointer-events: none;
`
